module.exports = __webpack_public_path__ + "img/qr-tracking-start.e025887e.svg";